<template>
  <div class="g-type3">
    <div class="m-box u-spw">
      <div class="u-halfbox">
        <!-- <a
          :href="
            'http://www.nbd.com.cn/corp/2019newspaper/tongweiArticle.html?article_id=' +
            this.elems[0].article_id +
            '&page=' +
            this.index+'&columnId='+this.columnId
          "
          class="g-twTitle"
          v-html="this.Breaks(elems[0].title)"
        >
    
        </a> -->
        <router-link :to="'/article/' + this.elems.articles[1].article_id"
          :class="'g-twTitle ' + elems.articles[1].title_font_size" v-html="this.Breaks(elems.articles[1].title)" v-if="this.elems.articles[1].article_id != null">
        </router-link>
        <a :href="this.elems.articles[1].article_url" v-else>{{elems.articles[1].title}}</a>
        <p :class="'g-twDesc ' + elems.articles[1].sub_title_font_size">
          {{ elems.articles[1].sub_title }}
        </p>

        <div @click.stop="support($event, elems.articles[1].article_id, elems.articles[1])" class="u-supportBox"
          v-if="elems.articles[1].parsing_article_flag">
          <img src="../../assets/tongwei/support.png" alt="" class="u-support">
          <img src="../../assets/tongwei/supportActive.png" alt="" class="u-supportActive">
          {{ elems.articles[1].support_counts }}
        </div>


      </div>
      <i class="u-hr"> </i>
      <div class="u-halfbox">
        <!-- <a
          :href="
            'http://www.nbd.com.cn/corp/2019newspaper/tongweiArticle.html?article_id=' +
            this.elems[1].article_id +
            '&page=' +
            this.index+'&columnId='+this.columnId
          "
          class="g-twTitle"
           v-html="this.Breaks(elems[1].title)"
        >
         
        </a> -->
        <router-link :to="'/article/' + this.elems.articles[2].article_id"
          :class="'g-twTitle ' + elems.articles[2].title_font_size" v-html="this.Breaks(elems.articles[2].title)"  v-if="this.elems.articles[2].article_id != null">
        </router-link>
        <a :href="this.elems.articles[2].article_url" v-else>{{elems.articles[2].title}}</a>
        <p :class="'g-twDesc ' + elems.articles[2].sub_title_font_size">
          {{ elems.articles[2].sub_title }}
        </p>
        <!-- <div @click.stop="support($event, elems.articles[2].article_id, elems.articles[2])" class="u-supportBox"
          v-if="elems.articles[2].parsing_article_flag">
          <img src="../../assets/tongwei/support.png" alt="" class="u-support">
          <img src="../../assets/tongwei/supportActive.png" alt="" class="u-supportActive">
          {{ elems.articles[2].support_counts }}
        </div> -->
      </div>
    </div>
    <div class="m-box u-spw">
      <div class="u-halfbox">
        <!-- <a
          :href="
            'http://www.nbd.com.cn/corp/2019newspaper/tongweiArticle.html?article_id=' +
            this.elems[2].article_id +
            '&page=' +
            this.index+'&columnId='+this.columnId
          "
          class="g-twTitle"
           v-html="this.Breaks(elems[2].title)"
        >
         
        </a> -->
        <router-link :to="'/article/' + this.elems.articles[3].article_id"
          :class="'g-twTitle ' + elems.articles[3].title_font_size" v-html="this.Breaks(elems.articles[3].title)" v-if="this.elems.articles[3].article_id != null">
        </router-link>
        <a :href="this.elems.articles[3].article_url" v-else>{{elems.articles[3].title}}</a>
        <p :class="'g-twDesc ' + elems.articles[3].sub_title_font_size">
          {{ elems.articles[3].sub_title }}
        </p>
        <!-- <div @click.stop="support($event, elems.articles[3].article_id, elems.articles[3])" class="u-supportBox"
          v-if="elems.articles[3].parsing_article_flag">
          <img src="../../assets/tongwei/support.png" alt="" class="u-support">
          <img src="../../assets/tongwei/supportActive.png" alt="" class="u-supportActive">
          {{ elems.articles[3].support_counts }}
        </div> -->
      </div>
      <i class="u-hr"> </i>
      <div class="u-halfbox">
        <!-- <a
          :href="
            'http://www.nbd.com.cn/corp/2019newspaper/tongweiArticle.html?article_id=' +
            this.elems[3].article_id +
            '&page=' +
            this.index+'&columnId='+this.columnId
          "
          class="g-twTitle"
           v-html="this.Breaks(elems[3].title)"
        >
          
        </a> -->
        <router-link :to="'/article/' + this.elems.articles[4].article_id"
          :class="'g-twTitle ' + elems.articles[4].title_font_size" v-html="this.Breaks(elems.articles[4].title)" v-if="this.elems.articles[4].article_id != null">
        </router-link>
        <a :href="this.elems.articles[4].article_url" v-else>{{elems.articles[4].title}}</a>
        <p :class="'g-twDesc ' + elems.articles[4].sub_title_font_size">
          {{ elems.articles[4].sub_title }}
        </p>
        <!-- <div @click.stop="support($event, elems.articles[4].article_id, elems.articles[4])" class="u-supportBox"
          v-if="elems.articles[4].parsing_article_flag">
          <img src="../../assets/tongwei/support.png" alt="" class="u-support">
          <img src="../../assets/tongwei/supportActive.png" alt="" class="u-supportActive">
          {{ elems.articles[4].support_counts }}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    elems: [Array, Object],
    index: [Number, String],
    columnId: [String, Number]
  },
};
</script>

<style lang="scss" scoped>
</style>